module.exports = __webpack_public_path__ + "static/media/Telegram.69627dbf.webp";